/**
 * Orelva · Shipping protection preselected in the cart drawer.
 * - Adds the protection automatically when the cart has products.
 * - Respects the customer's choice if they switch it off (per session).
 * - Removes it when the cart has no products.
 */
(function () {
  var OPT_OUT_KEY = 'orelva_sp_optout';
  var syncing = false;
  var pending = false;

  function config() {
    return window.orelvaShippingProtection || {};
  }

  function isOptedOut() {
    try {
      return window.sessionStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setOptedOut(value) {
    try {
      if (value) window.sessionStorage.setItem(OPT_OUT_KEY, '1');
      else window.sessionStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}
  }

  function cartRoot() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
  }

  function refreshDrawer() {
    return fetch(cartRoot() + '?view=drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var oldDrawer = document.querySelector('#CartDrawer');
        var newDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        if (!oldDrawer || !newDrawer) return;
        if (typeof window.updateCartDrawer === 'function') {
          window.updateCartDrawer(oldDrawer, newDrawer, false);
        } else {
          oldDrawer.innerHTML = newDrawer.innerHTML;
        }
      });
  }

  function sync() {
    var cfg = config();
    if (!cfg.variantId) return Promise.resolve();
    if (syncing) {
      pending = true;
      return Promise.resolve();
    }
    syncing = true;

    var protectionId = String(cfg.variantId);

    return fetch(cartRoot() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var protectionLine = null;
        var products = [];
        cart.items.forEach(function (item) {
          if (String(item.variant_id) === protectionId) protectionLine = item;
          else products.push(item);
        });

        var request = null;
        if (protectionLine && products.length === 0) {
          request = postJSON(cartRoot() + '/change.js', { id: protectionLine.key, quantity: 0 });
        } else if (protectionLine && protectionLine.quantity > 1) {
          request = postJSON(cartRoot() + '/change.js', { id: protectionLine.key, quantity: 1 });
        } else if (!protectionLine && products.length > 0 && !isOptedOut()) {
          request = postJSON(cartRoot() + '/add.js', { items: [{ id: Number(protectionId), quantity: 1 }] });
        }

        if (!request) return;
        return request.then(refreshDrawer);
      })
      .catch(function (err) {
        console.error('Orelva shipping protection sync failed', err);
      })
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          sync();
        }
      });
  }

  // Remember the customer's choice when they use the switch (capture phase runs before the theme handler).
  document.addEventListener(
    'click',
    function (event) {
      var label = event.target.closest && event.target.closest('.gb-shipping-protection-button label.switch');
      if (!label || event.target.tagName === 'INPUT') return;
      setOptedOut(label.classList.contains('checked'));
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    var events = window.PUB_SUB_EVENTS || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null);
    if (typeof window.subscribe === 'function' && events && events.cartUpdate) {
      window.subscribe(events.cartUpdate, function () {
        setTimeout(sync, 150);
      });
    }
    // Quantity changes and removals inside the drawer re-render it and emit this event.
    document.addEventListener('cart-drawer:update', function () {
      setTimeout(sync, 150);
    });
    sync();
  });

  window.orelvaSyncShippingProtection = sync;
})();
